"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_1 = require("@cian/analytics");
function trackAddNewbuildingToFavorites(oid, label, pageType) {
    analytics_1.ca('event', {
        action: pageType === 'card' ? 'add_from_card_JK' : 'add_from_listing_JK',
        category: 'favorite',
        label: label,
        name: 'oldevent',
        oid: oid,
    });
}
exports.trackAddNewbuildingToFavorites = trackAddNewbuildingToFavorites;
function trackRemoveNewbuildingFromFavorites(oid, label, pageType) {
    analytics_1.ca('event', {
        action: pageType === 'card' ? 'remove_from_card_JK' : 'remove_from_listing_JK',
        category: 'favorite',
        label: label,
        name: 'oldevent',
        oid: oid,
    });
}
exports.trackRemoveNewbuildingFromFavorites = trackRemoveNewbuildingFromFavorites;
function trackMotivationShow(label) {
    analytics_1.ca('event', {
        action: 'show_JK',
        category: 'SyncFavorites_popup',
        label: label,
        name: 'oldevent',
    });
}
exports.trackMotivationShow = trackMotivationShow;
function trackMotivationClose() {
    analytics_1.ca('event', {
        action: 'click_JK',
        category: 'SyncFavorites_popup',
        label: 'close',
        name: 'oldevent',
    });
}
exports.trackMotivationClose = trackMotivationClose;
function trackMotivationLoginClick() {
    analytics_1.ca('event', {
        action: 'click_JK',
        category: 'SyncFavorites_popup',
        label: 'goToLK',
        name: 'oldevent',
    });
}
exports.trackMotivationLoginClick = trackMotivationLoginClick;



//////////////////
// WEBPACK FOOTER
// ./src/shared/favorite_button/tracking.ts
// module id = 303
// module chunks = 2